var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "auto",
        title: "Preview QR Code",
        visible: _vm.dialogVisible,
        scrollbar: false,
        "z-index": 20001,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.onClosed,
        open: _vm.onOpen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "qrcode", attrs: { id: "qrcode" } },
        [
          _c(
            "el-image",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { src: _vm.qrcodeUrl },
            },
            [
              _c(
                "div",
                {
                  staticClass: "image-slot",
                  attrs: { slot: "error" },
                  slot: "error",
                },
                [_c("i", { staticClass: "el-icon-picture-outline" })]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }